import { ProfileNode } from './profile-node';

export class Topic {

    // Properties
    TopicId: number;
    children: ProfileNode[] = [];
    topLevelNode: ProfileNode;
    subLevelNodes: ProfileNode[] = [];
    first: boolean;
    last: boolean;

    // Class Functions
    get sequence(): number {
        if (this.topLevelNode) {
            return this.topLevelNode.data.newSequence != undefined ? this.topLevelNode.data.newSequence : this.topLevelNode.data.Sequence;
        } else {
            return -1;
        }
    }
}